export const parseBooleanValue = (value) => value && value === "true";
export const parseIntValue = (value) => value && parseInt(value, 10);
